import React, { Fragment, useMemo } from 'react'
import { MahasulListDetailsProps } from '../../../../helpers/models/Models'
import AppTable from '../../../../constants/AppTable'
import { formatMoney } from '../../../../helpers/DateFormat'
import { StatusBadge } from '../../../../constants/AppBadge'

interface PostToAccountListViewProps {
    onMahasulList: MahasulListDetailsProps[] | null
}
const PostToAccountListView: React.FC<PostToAccountListViewProps> = ({ onMahasulList }) => {
    const columns = [
        { header: 'SN', accessor: 'sn', sortable: false },
        { header: 'Member Name', accessor: 'mem_name', sortable: true },
        { header: 'Marga/Tole', accessor: 'marga_tole_name', sortable: false },
        { header: 'Consume Amt', accessor: 'consume_amt', sortable: false },
        { header: 'Consumer unit', accessor: 'consume_unit', sortable: false },
        { header: 'Unit Total', accessor: 'unit_total', sortable: false },
        { header: 'Address', accessor: 'add_eng', sortable: false },
        { header: 'Meter Status', accessor: 'meter_status', sortable: false },
        { header: 'Post', accessor: 'post', sortable: false },
        
    ];
    const modifiedData = useMemo(() => {
        if (!onMahasulList) return [];
        return onMahasulList.map((item: MahasulListDetailsProps) => ({
            sn: item.sn,
            mem_name: `${item.member_sn}. ${item.mem_name}`,
            marga_tole_name: item.tole_name,
            member_sn: item.member_sn,
            consume_amt: formatMoney(item.consume_amt || 0),
            consume_unit: item.consume_unit,
            unit_total: item.unit_total,
            add_eng: item.add_eng,
            post: item.post===1?<StatusBadge status={1}/>: <StatusBadge status={0}/>,
            meter_status: item.meter_status === 1 ? "Meter Bigreko" : item.meter_status === 2 ? 'Pani Khapat nabhayako' : item.meter_status === 3 ? 'Sewa Banda Bhayako' : "-",
        }));
    }, [onMahasulList]);
    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
            />
        </Fragment>
    )
}

export default PostToAccountListView